import React from 'react';
import { MarketingImage } from 'components/MarketingPagesShared/MarketingImage';
import {
  SwitchQuote,
  SwitchQuoteText,
  SwitchQuoteAuthor,
  SwitchQuotePodcast,
} from '../../styles';

export function QuotesLA() {
  return (
    <>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/es-LA/topexpansion"
          alt="Top Expansion Tecnologia podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor />
        <SwitchQuotePodcast>Top Expansión Tecnología</SwitchQuotePodcast>
        <SwitchQuoteText>
          “Los pódcast nos han acercado a nuevas audiencias con las que hemos
          conectado día con día en todas nuestras marcas. Conocer el perfil de
          estas audiencias, su edad, género y ciudad, nos ha ayudado a tener un
          mejor panorama y análisis de nuestros oyentes, a través de una
          plataforma eficaz y muy fácil de usar.”
        </SwitchQuoteText>
      </SwitchQuote>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/es-LA/escueladenada"
          alt="Escuela de nada podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor />
        <SwitchQuotePodcast>Escuela de Nada</SwitchQuotePodcast>
        <SwitchQuoteText>
          “Anchor ha resultado para nosotros una gran herramienta. No sólo por
          el acceso a métricas, sino por lo friendly que es de usar. Esto es
          importante porque así podemos concentrarnos en crear contenido y no
          tanto en el aspecto técnico de su distribución.”
        </SwitchQuoteText>
      </SwitchQuote>
      <SwitchQuote>
        <MarketingImage
          imagePath="switch/quotes/localized-assets/es-LA/laestrategia"
          alt="La estrategia del dia podcast cover"
          width={342}
          height={342}
        />
        <SwitchQuoteAuthor />
        <SwitchQuotePodcast>La Estrategia del Día</SwitchQuotePodcast>
        <SwitchQuoteText>
          “Anchor nos ha facilitado posicionarnos en Latinoamérica con La
          Estrategia del Día México, Colombia y Argentina. Es una herramienta
          fácil de usar, amigable y a un clic de distancia despliega grandes
          demográficos de los usuarios que te escuchan. Por eso y más, ha sido
          fundamental para tener visibilidad a nivel internacional.”
        </SwitchQuoteText>
      </SwitchQuote>
    </>
  );
}
